import React, { Component } from "react";
import CardNroContrato from "./CardNroContrato";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";

export default class Rueda2 extends Component {

  constructor(props) {
    super(props);
    this.filterInput = React.createRef();
    this.searchNumber = this.searchNumber.bind(this);
    this.cargarNroContratos = this.cargarNroContratos.bind(this);
    this.state = this.getInitialState();
    this.cardContrato = React.createRef();
    this.resetState = this.resetState.bind(this);
  }

  resetState = () => {
    this.setState(this.getInitialState());
    this.resetCardContrato();
    this.removeDisableGrilla();
  };

  resetCardContrato = () => {
    if (this.cardContrato.current !== null) {
      this.cardContrato.current.resetState();
      this.continuar.disabled = true;
    }
  };

  getInitialState = () => ({
    datosCuenta: [],
    toggle: true,
    porSuerte: false,
    nroContrato: -1,
  });

  initNroContrato = () => {
    this.setState({
      ...this.state,
      nroContrato: -1
    });
  }

  componentDidMount() {
    this.continuar.disabled = true;
  }

  isContratoVendido(array, value) {
    var respuesta = $.grep(array, function (obj) {
      return obj.numeroContrato.toString() === value.toString();
    });
    if (respuesta !== undefined && respuesta.length > 0) {
      return true;
    }
    return false;
  }

  filtrarContratos(array, value) {
    var respuesta = $.grep(array, function (obj) {
      return obj.numeroContrato.toString().includes(value.toString());
    });
    return respuesta;
  }

  cargarNroContratos() {

    if (this.continuar) this.enableNext();

    var valFilter =
      this.filterInput.current === null ? "" : this.filterInput.current.value;

    var filtrar = false;
    if (valFilter.trim() !== "") {
      filtrar = true;
    } else {
      filtrar = false;
    }

    var noDisponibles =
      this.props.grupo.atributoContratoRuedaDet === null ||
        this.props.grupo.atributoContratoRuedaDet === undefined
        ? []
        : this.props.grupo.atributoContratoRuedaDet;
    var cantSocios = this.props.grupo.cantSocio;
    cantSocios = String(cantSocios).replace(/\./g, "");
    cantSocios = Number(cantSocios);
    var contrato = [];
    var nroContratoFiltrado = [];

    for (var i = 0; i <= cantSocios - 1; i++) {
      if (filtrar && !i.toString().includes(valFilter)) {
        continue;
      }
      if (this.isContratoVendido(noDisponibles, i)) {
        contrato = {
          id: i,
          nroContrato: i,
          estado: "VENDIDO",
        };
      } else {
        contrato = {
          id: i,
          nroContrato: i,
          estado: "DISPONIBLE",
        };
        nroContratoFiltrado.push(contrato);
      }
    }

    return nroContratoFiltrado;
  }

  removeDisableGrilla() {
    document.getElementById("listado-contrato-rueda").classList.remove("rueda-inhabilitar-listado");
    document.getElementById("filtro-contrato").disabled = false;
    //document.getElementById("contrato-aleatorio").checked = false;
  }

  contratoAleatorio() {
    var checked = false;
    if (document.getElementById("contrato-aleatorio").checked) {
      this.removeDisableGrilla();
    } else {
      document
        .getElementById("listado-contrato-rueda")
        .classList.add("rueda-inhabilitar-listado");
      document.getElementById("filtro-contrato").disabled = true;
      document.getElementById("filtro-contrato").value = "";
      document.getElementById("contrato-aleatorio").checked = true;
      checked = true;
    }
    this.setState({ porSuerte: checked }, this.callBackChanges);
  }

  searchNumber(e) {
    const estado = this.state.toggle;
    this.setState({ toggle: !estado, nroContrato: -1 });
    this.resetCardContrato();

  }

  contratoSele = (_nroContrato) => {
    this.setState({ nroContrato: _nroContrato }, this.callBackChanges);
  };

  callBackChanges() {
    this.enableNext();
    this.props.returnDataPaso2(this.state.porSuerte, this.state.nroContrato);
  }

  enableNext() {

    const { porSuerte } = this.state;
    const { nroContrato } = this.state;

    if (porSuerte || nroContrato !== -1) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }
  }

  render() {
    const contratos = this.cargarNroContratos();

    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Número de Contrato</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  {/* <div className="col-6">
                    }<button
                      className="btn btn-outline-success"
                      data-toggle="modal"
                      data-target="#modal-contrato-aleatorio"
                    >
                      <i
                        className="fas fa-question-circle"
                        style={{ fontSize: "20px", color: "#0f7594" }}
                      ></i>{" "}
                      Ayuda
                    </button>
                  </div> */}
                 
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-2">
                    <br />
                    <b>Buscador Avanzado:</b>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <span style={{ fontSize: "small", color: "#adadad" }}>
                        de 0 a {this.props.grupo.totalContratos - 1}
                      </span>
                      <input
                        ref={this.filterInput}
                        style={{ textTransform: "lowercase" }}
                        onChange={this.searchNumber}
                        type="text"
                        placeholder="Buscar por Nro. de Contrato"
                        id="filtro-contrato"
                        className="input-box form-control"
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-3" style={{ paddingTop: 10 }}>
                    <div
                      className="rueda-voy-a-tener-suerte"
                      onClick={() => this.contratoAleatorio()}
                    >
                      <input
                        defaultChecked={this.state.porSuerte}
                        type="checkbox"
                        data-toggle="modal"
                        id="contrato-aleatorio"
                        onClick={() => this.contratoAleatorio()}
                      />
                      <span style={{ paddingLeft: 5 }}>
                        Seleccionar contrato al azar
                      </span>
                    </div>
                  </div> */}
                </div>
                <hr />
                <div
                  id="listado-contrato-rueda"
                  className="col-md-12 rueda-contrato-listado"
                >
                  <CardNroContrato
                    ref={this.cardContrato}
                    contratos={contratos}
                    contratoSele={this.contratoSele.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 col-md-6"></div>
              <div className="col-lg-2 col-md-3 btn-consulta">
              <button
                          className="btn btn-cu-quintary"
                          onClick={this.props.previousStep}
                        >
                        <FontAwesomeIcon icon={faArrowLeft} />  Volver
                        </button>
              </div>
              <div className="col-lg-2 col-md-3">
              <button
                          ref={(button) => (this.continuar = button)}
                          className="btn btn-cu-primary"
                          onClick={() => {
                            this.nextStep.click();
                          }}
                        >
                          {" "}
                          Continuar <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                        <button
                          hidden
                          ref={(a) => (this.nextStep = a)}
                          className="btn btn-cu-primary"
                          onClick={this.props.nextStep}
                        ></button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    );
  }
}
